import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from '@react-pdf/renderer'
import { useContext } from 'react'
import { TenantSettingsContext } from '../../App'

// Optional: custom fonts
// Font.register({ family: 'Open Sans', src: 'https://example.com/OpenSans-Regular.ttf' })

const styles = StyleSheet.create({
  page: {
    paddingTop: 50,
    paddingBottom: 30,
    paddingHorizontal: 30,
    flexDirection: 'column',
    fontSize: 10,
  },
  header: {
    position: 'absolute',
    top: 10,
    left: 30,
    right: 30,
    height: 50,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1 solid #ccc',
    paddingBottom: 15,
  },
  footer: {
    position: 'absolute',
    bottom: 10,
    left: 30,
    right: 30,
    fontSize: 8,
    color: 'grey',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerSection: {
    flex: 1,
  },
  centerText: {
    textAlign: 'center',
  },
  rightText: {
    textAlign: 'right',
  },
  tableHeader: {
    flexDirection: 'row',
    borderBottom: '1 solid #333',
    backgroundColor: '#eee',
    padding: 5,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1 solid #ddd',
    padding: 5,
  },
  cell: {
    flex: 1,
    paddingRight: 5,
    wordBreak: 'break-word',
  },
  bold: {
    fontWeight: 'bold',
  },
  logoWrapper: {
    height: 40,
    width: 100,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  logoImage: {
    height: '100%',
    width: 'auto',
    objectFit: 'contain',
    alignSelf: 'flex-start',
    marginRight: 'auto', // force it to stay to the left
  },
  ambunetImage: {},
})

const PDFDocument = ({
  columns = [],
  rows = [],
  orgLogo,
  documentTitle = 'Exported Data Report',
  printedBy,
}) => {
  const selectedCols = columns.filter((col) => col.renderForExport)

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.logoWrapper}>
            <Image style={styles.logoImage} src={orgLogo} />
          </View>
          <Text style={{ fontSize: 12, fontWeight: 'bold' }}>
            {documentTitle}
          </Text>
          {/* <Image style={styles.logo} src="/logo-right.png" /> */}
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          {selectedCols.map((col, idx) => (
            <Text key={idx} style={[styles.cell, styles.bold]}>
              {col.exportHeaderName ?? col.headerName}
            </Text>
          ))}
        </View>

        {/* Table Rows */}
        {rows.map((row, i) => (
          <View key={i} style={styles.tableRow} wrap={false}>
            {selectedCols.map((col, idx) => (
              <Text key={idx} style={styles.cell}>
                {col.renderForExport(row)}
              </Text>
            ))}
          </View>
        ))}

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text style={styles.footerSection}>
            Printed by {printedBy ?? 'Unknown'} on{' '}
            {new Date().toLocaleDateString()}
          </Text>
          <Text
            style={[styles.footerSection, styles.centerText]}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          />
          <Text style={[styles.footerSection, styles.rightText]}>
            Powered by AmbuNet®
          </Text>
        </View>
      </Page>
    </Document>
  )
}

export default PDFDocument
